import ImmoHeader from "../../immobilier/componnents/ImmoHeader";
import { useDispatch, useSelector } from "react-redux";
// import { setActiveView } from "../../../redux/actions/immobilierActions";
import ListeLotsEnregistres from "./ListeLotsEnregistres";
import ListeProgrammesEnregistres from "./ListeProgrammesEnregistres";
import {
  setEnregistresActiveOnglet,
  setEnregistresSingleProgramId,
  addEnregistresOpenLot,
  fetchEnregistresSingleLot,
} from "../../../redux/actions/enregistresActions";
import { useState, useEffect } from "react";
import { UserData } from "../../../redux/actions/userAuthActions";

const FavorisListe = () => {
  const [activeView, setActiveView] = useState("lots");
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.userAuthReducer);

  useEffect(() => {
    if (user) {
      const hasLots = user.lots_favoris && user.lots_favoris.length > 0;
      const hasProgrammes = user.programmes_favoris && user.programmes_favoris.length > 0;

      if (!hasLots && hasProgrammes) {
        setActiveView("programmes");
      } else if (hasLots && !hasProgrammes) {
        setActiveView("lots");
      } else if (hasLots && hasProgrammes) {
        setActiveView("lots");
      }
    }
  }, [user]);

  const handleProgramClick = (programId) => {
    dispatch(setEnregistresSingleProgramId(programId));
    dispatch(setEnregistresActiveOnglet("programme"));
    dispatch(UserData());
  };

  const handleLotClick = (lotId) => {
    dispatch(addEnregistresOpenLot(lotId));
    dispatch(fetchEnregistresSingleLot(lotId));
    dispatch(setEnregistresActiveOnglet(`lot-${lotId}`));
    dispatch(UserData());

  };
  const [lotsFilter, setLotsFilter] = useState("");
  const filteredLots = user?.lots_favoris.filter((lot) => {
    return lot?.reference?.toLowerCase().includes(lotsFilter?.toLowerCase());
  });

  const filteredPrograms = user?.programmes_favoris.filter((program) => {
    return program?.name?.toLowerCase().includes(lotsFilter?.toLowerCase());
  });
  return (
    <div>
      <ImmoHeader
        activeView={activeView}
        setActiveView={(view) => setActiveView(view)}
        carte={false}
        filterInput={lotsFilter}
        setFilterInput={setLotsFilter}
        filterBtn={false}
      />
      {activeView === "lots" ? (
        <>
          <ListeLotsEnregistres
            lotsFavoris={filteredLots}
            onLotClick={handleLotClick}
            filterInput={lotsFilter}
            setFilterInput={setLotsFilter}
          />
        </>
      ) : null}
      {activeView === "programmes" ? (
        <>
          <ListeProgrammesEnregistres
            programmesFavoris={filteredPrograms}
            onProgramClick={handleProgramClick}
            filterInput={lotsFilter}
            setFilterInput={setLotsFilter}
          />
        </>
      ) : null}
    </div>
  );
};

export default FavorisListe;
